import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { EmptySearchList } from '../../../../components/empty-search-list/index';

type WorkspaceBrowserNoMatchesProps = {
  className?: string;
  // A workspace's search stays inside it and says where else to look; the other spaces keep the
  // general wording.
  isWorkspace: boolean;
};

export const WorkspaceBrowserNoMatches: FC<WorkspaceBrowserNoMatchesProps> = ({
  className,
  isWorkspace,
}) => {
  if (!isWorkspace) return <EmptySearchList className={className} />;

  return (
    <EmptySearchList
      className={className}
      customDescriptionText={
        <span className="block max-w-[320px] whitespace-normal">
          <AppFormattedMessage id="NO_MATCHES_IN_WORKSPACE_HINT" />
        </span>
      }
      customTitleText={<AppFormattedMessage id="NO_MATCHES_IN_WORKSPACE" />}
    />
  );
};
